import React from "react";

export const ItemCast = ({ nameProp }) => {
  return (
    <>
      <div className="media-visualization-item">
        <p> {nameProp}</p>
      </div>
    </>
  );
};
export default ItemCast;
